<template lang="pug">
  WtActionMenu#challenge-forfeit-team-action-menu
    article.media(v-for="team in memberTeamsAdminInChallenge" @click="leaveChallenge(team)")
      figure.media-left
        p.image.is-48x48
          img.is-rounded(
            :src="_.get(team, 'logo', 'https://cdn.tbybewell.com/images/default-avatar.png')"
            alt="avatar"
            @error="teamAvatarOnError"
          )
      .media-content
        .content
          .has-text-weight-semibold {{ team.name }} &nbsp;&nbsp;
      .media-right
        .leave-challenge.has-text-danger
          .level
            BIcon(icon="flag-variant-outline")
            span Forfeit
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";

export default {
  name: "ChallengeForfeitTeamActionMenu",

  components: {
    WtButton,
    WtActionMenu
  },

  props: {
    challenge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isJoined: false
    };
  },

  computed: {
    ...mapGetters("program", ["programTeams"]),

    memberTeamsAdminInChallenge() {
      return this.challenge.teams.filter(team =>
        this._.get(team, "isAdmin", false)
      );
    }
  },

  methods: {
    ...mapActions("challenges", ["removeTeamsFromChallenge"]),
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["setPageLoaded"]),

    teamAvatarOnError(event) {
      event.target.onerror = null;
      event.target.src = "https://cdn.tbybewell.com/images/default-avatar.png";
    },

    leaveChallenge(team) {
      this.$buefy.dialog.confirm({
        title: "Remove Team From Challenge",
        confirmText: "Remove Team From Challenge",
        type: "is-danger",
        hasIcon: true,
        message: `Are you sure you want to remove ${team.name} from ${this.challenge.name}?`,
        onConfirm: async () => {
          if (this.challenge.id) {
            await this.removeTeamsFromChallenge({
              challengeId: this.challenge.id,
              teamIds: [team.id]
            }).then(response => {
              if (response && response.data.success) {
                // After leaving the challenge trigger a refetch for:
                // Challenges page and challenge detail page. NOTE: the Challenges page will not do a
                // full refetch if MyDashboard is "loaded". So, we also set MyDashboard to false.
                this.setPageLoaded({ key: "Challenges", value: false });
                this.setPageLoaded({
                  key: `Challenge${this.challenge.id}`,
                  value: false
                });
                this.setPageLoaded({
                  key: `MyDashboard`,
                  value: false
                });
                // using $router.push here to
                // go back to the Challenges page, which
                // triggers the created method (currently where the challenge data is loaded)
                this.$router.push({ name: "Challenges" });

                this.snackBar({
                  duration: 5000,
                  type: "is-success",
                  message:
                    team.name +
                    " is no longer participating in " +
                    this.challenge.name
                });
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
